import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../layout/header/header.component';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../services/auth/auth.service';
import { AlertComponent } from '../components/alert/alert.component';
import { environment } from '../environments/environment';
import { StepperService } from '../services/stepper.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,HeaderComponent,CommonModule,AlertComponent, TranslateModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  public token = localStorage.getItem('token')
  public isOpen: boolean = false
  public isLanguageOpen: boolean = false
  private defaultLanguage: string = "DE"
  public selectedLanguage: string = 'DE'
  public website = environment.websiteUrl
  public region = localStorage.getItem('region')
  
  title = 'pebra-web-app';

  constructor(private route: Router, private translate: TranslateService, private auth: AuthService, private stepperService: StepperService, private activatedRoute: ActivatedRoute){
    this.auth.authToken$.subscribe(token => {
      this.token = token
    })
  }
  ngOnInit(): void {
    this.selectedLanguage = localStorage.getItem("selectedLanguage") || this.defaultLanguage;
    localStorage.removeItem('selectedZip')
    this.activatedRoute.queryParams.subscribe(params => {
      const queryParams = params['region']
      this.region === queryParams
    })
  }
  
  login() {
    if(this.token){
      this.route.navigate(['profile'])
    } else {
      this.route.navigate(['login'])
    }
  }
  
  handleIsOpenChange(isOpen:boolean){
    this.isOpen = isOpen
  }

  /**
   * 
   * @param lang 
   */
  
  selectLang(lang: string) {
    if (lang === 'EN') {
    this.selectedLanguage = 'EN';
    this.translate.use('en');
    localStorage.setItem("selectedLanguage", "EN");
  } else if (lang === 'DE') {
    this.selectedLanguage = 'DE';
    this.translate.use('de');
    localStorage.setItem("selectedLanguage", "DE")
  }
  this.isLanguageOpen = false;
}

  handleOpenLanguage(){
    this.isLanguageOpen = !this.isLanguageOpen
  }

  stepButton(direction: string) {
    this.stepperService.stepButtonFn?.(direction);
  }

  disableNext(): boolean {
    return this.stepperService.disableNextFn?.() ?? true;
  }

  isLastStep(): boolean {
    return this.stepperService.isLastStepFn?.() ?? false;
  }

  loginFromStepper() {
    this.stepperService.loginFromStepperFn?.();
  }

  registerFromStepper() {
    this.stepperService.registerFromStepperFn?.();
  }
  isButtonDisabled(): boolean {
    return this.stepperService.isButtonDisabled();
  }
  get isLoginButton(): boolean {
    return this.stepperService.isLoginButton;
  }

  get isRegisterButton(): boolean {
    return this.stepperService.isRegisterButton;
  }

  get changeButton(): boolean {
    return this.stepperService.changeButton;
  }

  get loading(): boolean {
    return this.stepperService.loading;
  }

  get hasAcceptedTerms(): boolean {
    return this.stepperService.hasAcceptedTerms;
  }

  get hasAcceptedMarketingConsent(): boolean {
    return this.stepperService.hasAcceptedMarketingConsent;
  }

  get isCompany(): boolean {
    return this.stepperService.isCompany;
  }

}
